import React from "react";
import PropTypes from "prop-types";
import ModalDialog from "../../controls/ModalDialog";
import CreateUserInfo from "./CreateUserInfo";

const CreateUserDialog = props => {

    const { show, onCancel, onSave } = props;

    const buttons = [{
        bsStyle: "default",
        cssClass: "btn",
        onClick: onCancel,
        key: "cancel",
        text: "Cancel"
    }, {
        bsStyle: "primary",
        cssClass: "btn btn-primary",
        onClick: onSave,
        key: "save",
        text: "Save"
    }];

    const content = (<div id="UserSettingsContainer">
        <CreateUserInfo validationResult={props.validationResult} hideErrorSummary={props.hideErrorSummary}/>
    </div>);

    return (
        <ModalDialog id={"createUserDialog"}
            className=".bs-table-modal-sm2"
            title={"Create New User"}
            content={content}
            buttons={buttons}
            onDocumentClose={onCancel}
            show={show}/>
    );
};

CreateUserDialog.propTypes = {
    id: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    validationResult: PropTypes.object,
    hideErrorSummary: PropTypes.func
};

export default CreateUserDialog;



